import { OverlayRef } from '@angular/cdk/overlay';
import { Component, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router, RouterState } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Subscription } from 'rxjs';
import { Auth } from 'src/app/models/auth';
import { CentroCusto } from 'src/app/models/centro-custo';
import { Collaborator } from 'src/app/models/collaborator';
import { CollaboratorFilter } from 'src/app/models/collaborator-filter';
import { Departamento } from 'src/app/models/departamento';
import { PedidoCadastro } from 'src/app/models/pedido-cadastro';
import { Order, OrderItens, Purchase, PurchaseItens } from 'src/app/models/purchase';
import { Unidade } from 'src/app/models/unidade';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CentroCustoService } from 'src/app/services/centro-custo.service';
//#region Service
import { ColaboradorService } from 'src/app/services/colaborador.service';
import { DepartamentoService } from 'src/app/services/departamento.service';
import { GestorService } from 'src/app/services/gestor.service';
import { PedidoDataService } from 'src/app/services/pedido-data.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { UnidadeService } from 'src/app/services/unidade.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
//#endregion
//#region Enum
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { DropDownItem } from 'src/app/shared/helpers/models/dropdown-item';
import { INovoPedido } from 'src/app/shared/interfaces/novo-pedido.interface';
import { environment } from '../../../../../../environments/environment';
import { ModalFilterColaboradorPipe } from '../../../../../shared/pipes/modal-filter-colaborador.pipe';



//#endregion


@Component({
    selector: 'app-nova-compra-colaborador',
    templateUrl: './nova-compra-colaborador.component.html',
    styleUrls: ['./nova-compra-colaborador.component.css']
})
export class NovacompraColaboradorComponent implements OnInit, INovoPedido {

    //#region Filtro
    public filtroNome: string;
    public filtroCPF: string;
    public filtroMatricula: string;
    public filtroCentroCusto: string;
    public filtroUnidade: string;
    public filtroDepartamento: string;
    public filtroPesquisa: string;
    public filtroPesquisaSporadic: string;
    //#endregion

    colaboradorSelect: boolean;

    //#region Paginação
    currentPage = 1;
    currentPageModal = 1;
    showItem = '100';
    //#endregion

    public cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];

    public collaboratorsId: any[]=[];
    public colaboradores: Collaborator[];
    public colaboradoresList: Collaborator[]=[];
    public centrosCustosList: CentroCusto[];
    public unidadesList: Unidade[];
    public departamentosList: Departamento[];
    private currentUser: Auth;
    private currentPedidoValue: PedidoCadastro;
    private currentPurchaseValue: Purchase;
    public colaboradorProduto: any;
    public orderItens: OrderItens[];

    public purchase: Purchase;
    public gestorId: number;
    public cedenteId: number;
    public product: string;

    public count = 0;
    public selectAllItem: boolean;
    public totalColaboradores: number;
    public isEmpty: boolean;

    //#region filtro DropDown
    public filtroCentroCustoDropDownList = [];
    public filtroCentroCustoSelectedItems = [];
    public filtroUnidadeDropDownList = [];
    public filtroUnidadeSelectedItems = [];
    public filtroDepartamentoDropDownList = [];
    public filtroDepartamentoSelectedItems = [];
    public filtroWithoutGroup: boolean = false;

    public dropDownSettings: IDropdownSettings = {};

    public costCenterCtrl: FormControl = new FormControl();
    public unitCtrl: FormControl = new FormControl();
    public departmentCtrl: FormControl = new FormControl();
    public productCtrl: FormControl = new FormControl();
    public appCtrl: FormControl = new FormControl();
    public situationCtrl: FormControl = new FormControl();
    public nameCtrl: FormControl = new FormControl();
    public cpfCtrl: FormControl = new FormControl();
    public registerCtrl: FormControl = new FormControl();
    //#endregion
    public alterado = false;


    //#region Ordenação
    sortOrder: boolean = false;
    totalItems: number;
    collumnName: string = "name";
    filtroOn: boolean;
    //#endregion

    //#region Menu de Contexto
    overlayRef: OverlayRef | null;
    subscription: Subscription;
    @ViewChild('contextMenu', { static: true }) contextMenu: TemplateRef<any>;
    //#endregion

    @ViewChild('modalColaboradorEsporadico', { static: true }) modalColaboradorEsporadico: TemplateRef<any>;
    @ViewChild('noSelectColaborador', { static: true }) noSelectColaborador: TemplateRef<any>;
    @ViewChild('noColaborador', { static: true }) noColaborador: TemplateRef<any>;


    constructor(
        private router: Router,
        private route: ActivatedRoute,
        public viewContainerRef: ViewContainerRef,
        private gestorService: GestorService,
        private modalService: NgbModal,
        private colaboradorService: ColaboradorService,
        private alertService: NewAlertService,
        private authenticationService: AuthenticationService,
        private pedidoDataService: PedidoDataService,
        private pedidoService: PedidoService,
        private centroCustoService: CentroCustoService,
        private unidadeService: UnidadeService,
        private departamentoService: DepartamentoService,
        private pipeModalFilterColaboradorPipe: ModalFilterColaboradorPipe) {
    }

    load() {}

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        this.currentPurchaseValue = this.pedidoDataService.currentPurchaseValue;
        this.loadPage(1);
        this.loadFiltroDropDown();
        this.gestorId = 0;
        this.cedenteId = 0;
        this.gestorService.getAll(this.currentUser.token.assignorGuid).subscribe(
            response => {

                this.gestorId = response.result[0].gestorId;
                this.cedenteId = response.result[0].cedenteId;

            });

        this.purchase = new Purchase(0,'');
        this.purchase.purchaseItens = [];
        this.purchase.managerGuid = this.currentUser.token.userReferenceId;
        this.purchase.purchaseItens.forEach( e => {
            e.order.orderItens = [];
        });
    }

    loadPage(event) {
        let product = [];
        for(let i = 0; i < this.currentPurchaseValue.purchaseItens.length; i++)
            product[i] = this.currentPurchaseValue.purchaseItens[i].order.productGuid;

        this.currentPage = event;
        const offset = this.currentPage - 1;

        const filterObject = new CollaboratorFilter();

        filterObject.query = this.filtroPesquisa;
        filterObject.products = product;
        filterObject.name = this.filtroNome;
        filterObject.document = this.filtroCPF;
        filterObject.register = this.filtroMatricula;
        filterObject.orderby = this.collumnName;
        filterObject.ordertype = this.sortOrder;
        filterObject.situation = "";
        filterObject.withoutGroup = this.filtroWithoutGroup;

        filterObject.costCenter = this.filtroCentroCustoSelectedItems.map((i) => Number(i));
        filterObject.unit = this.filtroUnidadeSelectedItems.map((i) => Number(i));
        filterObject.departament = this.filtroDepartamentoSelectedItems.map((i) => Number(i));

        this.alertService.clear();
        this.colaboradorService.postColaboradoresPedido(
            this.currentUser.token.assignorGuid,
            offset,
            +this.showItem,
            filterObject
        )
        .subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.colaboradores = response.result.collaborators;
                    if(response.result.totalResults <= 0 ){
                        this.totalItems = response.result.totalResults;
                        //this.modalService.open(this.noColaborador, { centered: true, size: 'lg', backdrop: 'static' });
                        return;
                    }
                    for (const s of this.colaboradores) {
                        s.selected = this.collaboratorsId.find(e => e === s.collaboratorID)? true : false;

                        if(s.document != null){
                            const tam =
                                environment.TOTAL_CARACTERE_CPF -
                                s.document.length;
                            let str = s.document.toString();

                            for (let i = 0; i < tam; i++) {
                                str = '0' + str;
                            }

                            s.document = str;
                        }

                        if (s.costCenter === null) {
                            s.costCenter = 'Nenhum';
                        }

                        if (s.unit === null) {
                            s.unit = 'Nenhum';
                        }

                        if (s.departament === null) {
                            s.departament = 'Nenhum';
                        }

                    }
                    this.totalItems = response.result.totalResults;
                } else {
                    this.alertService.error(response.message);
                }
            },
            error => {
                this.alertService.error(
                    'Ocorreu um erro ao paginar favorecidos'
                );
            }
        );
    }

    showItemChanged(event) {
        this.showItem = event;
        this.loadPage(1);
    }

    //#region Filtro DropDown
    public loadFiltroDropDown() {
        this.centroCustoService.getAll(this.currentUser.token.assignorGuid).subscribe(
            response => {
                this.centrosCustosList = response.result;
                this.centrosCustosList.forEach(obj => {
                    this.filtroCentroCustoDropDownList.push(new DropDownItem(obj.centroCustoId.toString(), obj.nome));
                });
            }
        );

        this.unidadeService.getAll(this.currentUser.token.assignorGuid).subscribe(
            response => {
                this.unidadesList = response.result;
                this.unidadesList.forEach(obj => {
                    this.filtroUnidadeDropDownList.push(new DropDownItem(obj.unidadeId.toString(), obj.nome));
                });
            }
        );

        this.departamentoService.getAll(this.currentUser.token.assignorGuid).subscribe(
            response => {
                this.departamentosList = response.result;
                this.departamentosList.forEach(obj => {
                    this.filtroDepartamentoDropDownList.push(new DropDownItem(obj.departamentoId.toString(), obj.nome));
                });
            }
        );

        this.dropDownSettings = {
            singleSelection: false,
            idField: 'ITEM_ID',
            textField: 'ITEM_TEXT',
            selectAllText: 'Selecionar Tudo',
            unSelectAllText: 'Desmarcar Tudo',
            searchPlaceholderText: 'Buscar',
            allowSearchFilter: true,
            itemsShowLimit: 3
        };
    }

    onItemSelectFiltroCentroCusto(item: any) { }
    onSelectAllFiltroCentroCusto(items: any) { }
    onItemDeSelectFiltroCentroCusto(items: any) { }

    onItemSelectFiltroUnidade(item: any) { }
    onSelectAllFiltroUnidade(items: any) { }
    onItemDeSelectFiltroUnidade(items: any) { }

    onItemSelectFiltroDepartamento(item: any) { }
    onSelectAllFiltroDepartamento(items: any) { }
    onItemDeSelectFiltroDepartamento(items: any) { }
    //#endregion

    public savePedido() {
       for (let i = 0; i < this.currentPurchaseValue.purchaseItens.length; i++) {

            this.setSelected(i);
            this.purchase.purchaseItens[i] = new PurchaseItens();
            this.purchase.purchaseItens[i].order = new Order();
            this.purchase.purchaseItens[i].order.orderItens = [];
            this.purchase.assignorId = this.cedenteId;
            this.purchase.purchaseValue = 0;
            this.purchase.purchaseItens[i].order.assignorContractId = this.currentPurchaseValue.purchaseItens[i].order.assignorContractId;
            this.purchase.purchaseItens[i].order.managerId = this.gestorId;
            this.purchase.purchaseItens[i].order.productDescription = this.currentPurchaseValue.purchaseItens[i].order.productDescription;
            this.purchase.purchaseItens[i].order.productGuid = this.currentPurchaseValue.purchaseItens[i].order.productGuid;

            this.purchase.purchaseDescription = (this.currentPurchaseValue.purchaseDescription === null ? '':this.currentPurchaseValue.purchaseDescription);
            this.purchase.identifier = (this.currentPurchaseValue.purchaseDescription === null ? '':this.currentPurchaseValue.purchaseDescription);

            this.purchase.purchaseItens[i].productId = this.currentPurchaseValue.purchaseItens[i].productId;
            this.purchase.purchaseItens[i].ehEditavel = this.currentPurchaseValue.purchaseItens[i].ehEditavel;
            this.purchase.purchaseItens[i].order.orderItens = [];

            const auxOrderItem = [];
            for (let aux = 0; aux < this.currentPurchaseValue.purchaseItens[i].order.orderItens.length; aux++) {

                const auxOrderItem: OrderItens = new OrderItens();
                auxOrderItem.cardId = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].cardId;
                auxOrderItem.comments = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].comments;

                auxOrderItem.document = parseInt(this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].document);
                auxOrderItem.hasApp = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].hasApp;
                auxOrderItem.hasCard = this.colaboradoresList[i].hasCard;
                auxOrderItem.name = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].name;
                auxOrderItem.registry = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].registry;
                auxOrderItem.regularityId = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].regularityId;
                auxOrderItem.regularityDescription = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].regularityDescription;
                auxOrderItem.referenceValue = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].referenceValue;
                auxOrderItem.providedValue = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].providedValue;

                this.purchase.purchaseItens[i].order.orderItens.push(auxOrderItem);
            }

        }

        this.pedidoService.createPurchase(this.currentUser.token.assignorGuid, this.purchase).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    for (let i = 0; i < this.currentPurchaseValue.purchaseItens.length; i++) {


                        this.purchase.purchaseId = response.result.purchaseId;
                        this.purchase.purchaseItens[i].order.orderId = response.result.purchaseItens[i].order.orderId;
                        this.purchase.purchaseItens[i].order.orderDescription = response.result.purchaseItens[i].order.orderDescription;
                        this.purchase.purchaseItens[i].purchaseItemId = response.result.purchaseItens[i].purchaseItemId;
                        this.purchase.purchaseItens[i].purchaseId = response.result.purchaseId;;

                        this.pedidoDataService.setCurrentPurchaseValue(this.purchase);
                    }
                    this.pedidoService.updatePurchase(this.currentUser.token.assignorGuid, this.purchase).subscribe(
                        res => {
                            if (response.status === ApiError.Sucesso) {
                                this.alertService.success('Recarga salva');
                            } else {
                                this.alertService.success('Erro ao salvar a recarga');
                            }
                    });

                } else {
                    this.alertService.error(response.message);
                }
            },
            error => {
                this.alertService.error(error);
            }
        );
    }


    orderBy(collumnName: string, sortOrder: boolean) {
        this.collumnName=collumnName;
        this.sortOrder=sortOrder;
        this.loadPage(1);
        /*this.colaboradoresList.sort(
            (a, b) => {
                const dftl = sortOrder ? Number.MAX_VALUE : -Number.MAX_VALUE;
                const aVal = (a[collumnName] === null ? dftl : a[collumnName]).toString();
                const bVal = (b[collumnName] === null ? dftl : b[collumnName]).toString();
                let result = aVal.localeCompare(bVal, undefined, { numeric: true });
                if (sortOrder) {
                    result = bVal.localeCompare(aVal, undefined, { numeric: true });
                }
                return result;
            }
        );*/
    }

    applyFilter() {
        if(this.nameCtrl.value != null)
            this.filtroNome = this.nameCtrl.value;
        if(this.cpfCtrl.value != null)
            this.filtroCPF = this.cpfCtrl.value;
        if(this.registerCtrl.value != null)
            this.filtroMatricula = this.registerCtrl.value;
        if(this.costCenterCtrl.value != null)
            this.filtroCentroCustoSelectedItems = this.costCenterCtrl.value;
        if(this.unitCtrl.value != null)
            this.filtroUnidadeSelectedItems = this.unitCtrl.value;
        if(this.departmentCtrl.value != null)
            this.filtroDepartamentoSelectedItems = this.departmentCtrl.value;
        if(
            this.filtroNome == "" &&
            this.filtroCPF == "" &&
            this.filtroCPF == "" &&
            this.filtroMatricula == "" &&
            this.filtroCentroCustoSelectedItems.length == 0 &&
            this.filtroUnidadeSelectedItems.length == 0 &&
            this.filtroDepartamentoSelectedItems.length == 0 &&
            !this.filtroWithoutGroup
        ){
            this.filtroOn = false;
        } else {
            this.filtroOn = true;
        }

        this.loadPage(1);
    }

    updateCount() {
        this.count = this.colaboradoresList.filter(x => x.selected).length;
    }

    selectAll(value: boolean) {
        this.selectAllItem = !this.selectAllItem;
        this.colaboradores.forEach(item => {
            item.selected = this.selectAllItem
            if (this.selectAllItem && !this.collaboratorsId.find(e => e === item.collaboratorID)) {
                this.colaboradoresList.push(item);
                this.collaboratorsId.push(item.collaboratorID);
            } else {
                this.colaboradoresList = this.colaboradoresList.filter(e => e.collaboratorID !== item.collaboratorID);
                this.collaboratorsId = this.collaboratorsId.filter(e => e  !== item.collaboratorID);
            }
        });

        this.count = this.collaboratorsId.length;
        /*this.count = this.collaboratorsId.length;
        const colaboradores = this.pipeModalFilterColaboradorPipe
            .transform(this.colaboradoresList, this.filtroPesquisa, '', this.filtroNome, this.filtroCPF,
                this.filtroMatricula, this.filtroCentroCusto, this.filtroUnidade, this.filtroDepartamento, '');
        colaboradores.forEach(obj => {
            if (this.colaboradoresList.find(x => x.colaboradorId === obj.colaboradorId)) {
                obj.selected = value;
            }
        });
        this.updateCount();*/
    }

    selectElement(item: Collaborator) {
        item.selected = !item.selected;

        if (item.selected && !this.collaboratorsId.find(e => e === item.collaboratorID)) {
            this.colaboradoresList.push(item);
            this.collaboratorsId.push(item.collaboratorID);
        } else {
            this.colaboradoresList = this.colaboradoresList.filter(e => e.collaboratorID !== item.collaboratorID);
            this.collaboratorsId = this.collaboratorsId.filter(e => e  !== item.collaboratorID);
        }

        this.count = this.collaboratorsId.length;
    }

    showFilter(content: any) {
        this.modalService.open(content, { centered: true, size: 'lg' });
    }
    removerFilter(){
        this.filtroNome = '';
        this.filtroCPF = '';
        this.filtroMatricula = '';
        this.filtroCentroCustoSelectedItems = [];
        this.filtroUnidadeSelectedItems = [];
        this.filtroDepartamentoSelectedItems = [];
        this.filtroOn = false;
        this.filtroWithoutGroup = false;

        this.loadPage(1);
    }

    showModal(content: any) {
        this.modalService.open(content, { centered: true, size: 'lg' });
    }


    public previous() {
        this.router.navigate(['create'], { relativeTo: this.route.parent });
    }

    public next() {
        const nextPage = false;
        for (let i = 0; i < this.currentPurchaseValue.purchaseItens.length; i++) {
            this.setSelected(i);
            this.pedidoDataService.setCurrentPurchaseValue(this.currentPurchaseValue);

            this.purchase.purchaseItens[i] = new PurchaseItens();
            this.purchase.purchaseItens[i].order = new Order();
            this.purchase.purchaseItens[i].order.orderItens = [];
            this.purchase.assignorId = this.cedenteId;
            this.purchase.purchaseValue = 0;
            this.purchase.flexIndividual = this.currentPurchaseValue.flexIndividual;
            this.purchase.purchaseItens[i].order.assignorContractId = this.currentPurchaseValue.purchaseItens[i].order.assignorContractId;
            this.purchase.purchaseItens[i].order.managerId = this.gestorId;
            this.purchase.purchaseItens[i].order.productDescription = this.currentPurchaseValue.purchaseItens[i].order.productDescription;
            this.purchase.purchaseItens[i].order.productGuid = this.currentPurchaseValue.purchaseItens[i].order.productGuid;
            this.purchase.purchaseItens[i].order.productCategory = this.currentPurchaseValue.purchaseItens[i].order.productCategory;
            this.purchase.purchaseItens[i].order.totalFeePercent = this.currentPurchaseValue.purchaseItens[i].order.totalFeePercent;

            this.purchase.purchaseDescription = (this.currentPurchaseValue.purchaseDescription === null ? '':this.currentPurchaseValue.purchaseDescription);
            this.purchase.identifier = (this.currentPurchaseValue.purchaseDescription === null ? '':this.currentPurchaseValue.purchaseDescription);

            this.purchase.purchaseItens[i].productId = this.currentPurchaseValue.purchaseItens[i].productId;
            this.purchase.purchaseItens[i].ehEditavel = this.currentPurchaseValue.purchaseItens[i].ehEditavel;
            this.purchase.purchaseItens[i].order.isPercent = this.currentPurchaseValue.purchaseItens[i].order.isPercent;
            this.purchase.purchaseItens[i].order.orderItens = [];
            for (let aux = 0; aux < this.currentPurchaseValue.purchaseItens[i].order.orderItens.length; aux++) {

                const auxOrderItem: OrderItens = new OrderItens();
                auxOrderItem.collaboratorId = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].collaboratorId;
                auxOrderItem.cardId = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].cardId;
                auxOrderItem.comments = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].comments;
                if(this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].document != null){
                    auxOrderItem.document = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].document.toString();}
                else
                    auxOrderItem.document = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].document;
                auxOrderItem.hasApp = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].hasApp;
                auxOrderItem.hasCard = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].hasCard;
                auxOrderItem.name = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].name;
                auxOrderItem.registry = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].registry;
                auxOrderItem.regularityId = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].regularityId;
                auxOrderItem.regularityDescription = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].regularityDescription;
                auxOrderItem.referenceValue = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].referenceValue;
                auxOrderItem.providedValue = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].providedValue;

                this.purchase.purchaseItens[i].order.orderItens.push(auxOrderItem);
            }
        }
        if(this.currentPurchaseValue.purchaseId === null || this.currentPurchaseValue.purchaseId === 0 || this.currentPurchaseValue.purchaseId === undefined){
            if (this.currentPurchaseValue.purchaseItens[0].order.orderItens.length > 0) {
                this.pedidoService.createPurchase(this.currentUser.token.assignorGuid, this.purchase).subscribe(
                    res => {
                        if (res.status === ApiError.Sucesso){
                            for (let i = 0; i < this.currentPurchaseValue.purchaseItens.length; i++) {
                                this.purchase.purchaseItens[i].order.productIcon = res.result.purchaseItens[i].order.productIcon;
                                this.purchase.purchaseItens[i].order.productColor = res.result.purchaseItens[i].order.productColor;
                                this.purchase.purchaseItens[i].order.orderId = res.result.purchaseItens[i].order.orderId;
                                this.purchase.purchaseItens[i].order.orderDescription = res.result.purchaseItens[i].order.orderDescription;
                                for(let j = 0; j < this.currentPurchaseValue.purchaseItens[i].order.orderItens.length; j++){
                                    this.purchase.purchaseItens[i].order.orderItens[j].orderItemId = res.result.purchaseItens[i].order.orderItens[j].orderItemId;
                                    this.purchase.purchaseItens[i].order.orderItens.forEach(obj => {
                                        this.currentPurchaseValue.purchaseItens[i].order.orderId = res.result.purchaseItens[i].order.orderId;
                                        this.currentPurchaseValue.purchaseItens[i].order.orderItens[j].orderItemId = res.result.purchaseItens[i].order.orderItens[j].orderItemId;
                                    });
                                    let card = this.purchase.purchaseItens[i].order.orderItens[j].cardId;
                                    if(card === null || card === 0 || card === undefined){
                                        this.purchase.purchaseItens[i].order.orderItens.forEach(obj => {
                                            this.purchase.purchaseItens[i].order.orderItens[j].cardId = res.result.purchaseItens[i].order.orderItens[j].cardId;
                                            this.purchase.purchaseItens[i].order.orderItens[j].referenceValue = res.result.purchaseItens[i].order.orderItens[j].referenceValue;
                                            this.purchase.purchaseItens[i].order.orderItens[j].providedValue = res.result.purchaseItens[i].order.orderItens[j].providedValue;
                                            this.purchase.purchaseItens[i].order.orderItens[j].regularityId = res.result.purchaseItens[i].order.orderItens[j].regularityId;
                                            this.purchase.purchaseItens[i].order.orderItens[j].regularityDescription = res.result.purchaseItens[i].order.orderItens[j].regularityDescription;
                                        });
                                    }
                                }
                            }

                            this.purchase.purchaseId = 0;
                            this.purchase.purchaseId = res.result.purchaseId;
                            for (let i = 0; i < res.result.purchaseItens.length; i++) {
                                this.purchase.purchaseItens[i].purchaseItemId = 0;
                                this.purchase.purchaseItens[i].purchaseItemId = res.result.purchaseItens[i].purchaseItemId;
                                this.purchase.purchaseItens[i].purchaseId = this.purchase.purchaseId;
                            }

                            this.pedidoDataService.setCurrentPurchaseValue(this.purchase);
                            this.router.navigate(['selecaoperiodo'], { relativeTo: this.route.parent });
                        }
                    });
            }
            else {
                this.alertService.error('Você precisa selecionar ao menos um favorecido');
            }
        }else{
            if (this.currentPurchaseValue.purchaseItens[0].order.orderItens.length > 0) {
                if(this.currentPurchaseValue.purchaseDate != null || this.currentPurchaseValue.purchaseDate != undefined){
                    this.purchase.needChangeDate = true;
                }
                this.purchase.purchaseId = this.currentPurchaseValue.purchaseId;
                this.purchase.purchaseUseBalance = this.currentPurchaseValue.purchaseUseBalance != undefined ? this.currentPurchaseValue.purchaseUseBalance : false;
                this.purchase.paymentMethodId = this.currentPurchaseValue.paymentMethodId != undefined ? this.currentPurchaseValue.paymentMethodId : 0;
                for(let i = 0; i < this.currentPurchaseValue.purchaseItens.length; i++){
                    this.purchase.purchaseItens[i].purchaseItemId = this.currentPurchaseValue.purchaseItens[i].purchaseItemId;
                    this.purchase.purchaseItens[i].order.orderId = this.currentPurchaseValue.purchaseItens[i].order.orderId;
                }
                this.pedidoService.updatePurchase(this.currentUser.token.assignorGuid, this.purchase).subscribe(
                    res => {
                        if (res.status === ApiError.Sucesso){
                            for (let i = 0; i < this.currentPurchaseValue.purchaseItens.length; i++) {
                                this.purchase.purchaseItens[i].order.productIcon = res.result.purchaseItens[i].order.productIcon;
                                this.purchase.purchaseItens[i].order.productColor = res.result.purchaseItens[i].order.productColor;
                                this.purchase.purchaseItens[i].order.orderId = res.result.purchaseItens[i].order.orderId;
                                this.purchase.purchaseItens[i].order.orderDescription = res.result.purchaseItens[i].order.orderDescription;
                                for(let j = 0; j < this.currentPurchaseValue.purchaseItens[i].order.orderItens.length; j++){
                                    this.purchase.purchaseItens[i].order.orderItens[j].orderItemId = res.result.purchaseItens[i].order.orderItens[j].orderItemId;
                                    this.purchase.purchaseItens[i].order.orderItens.forEach(obj => {
                                        this.currentPurchaseValue.purchaseItens[i].order.orderId = res.result.purchaseItens[i].order.orderId;
                                        this.currentPurchaseValue.purchaseItens[i].order.orderItens[j].orderItemId = res.result.purchaseItens[i].order.orderItens[j].orderItemId;
                                    });
                                    let card = this.purchase.purchaseItens[i].order.orderItens[j].cardId;
                                    if(card === null || card === 0 || card === undefined){
                                        this.purchase.purchaseItens[i].order.orderItens.forEach(obj => {
                                            this.purchase.purchaseItens[i].order.orderItens[j].cardId = res.result.purchaseItens[i].order.orderItens[j].cardId;
                                            this.purchase.purchaseItens[i].order.orderItens[j].referenceValue = res.result.purchaseItens[i].order.orderItens[j].referenceValue;
                                            this.purchase.purchaseItens[i].order.orderItens[j].providedValue = res.result.purchaseItens[i].order.orderItens[j].providedValue;
                                            this.purchase.purchaseItens[i].order.orderItens[j].regularityId = res.result.purchaseItens[i].order.orderItens[j].regularityId;
                                            this.purchase.purchaseItens[i].order.orderItens[j].regularityDescription = res.result.purchaseItens[i].order.orderItens[j].regularityDescription;
                                        });
                                    }
                                }

                            }
                            this.purchase.purchaseId = res.result.purchaseId;
                            for (let i = 0; i < res.result.purchaseItens.length; i++) {
                                this.purchase.purchaseItens[i].purchaseItemId = res.result.purchaseItens[i].purchaseItemId;
                                this.purchase.purchaseItens[i].purchaseId = this.purchase.purchaseId;
                            }

                            this.pedidoDataService.setCurrentPurchaseValue(this.purchase);
                            this.router.navigate(['selecaoperiodo'], { relativeTo: this.route.parent });
                        }
                    });

            }
            else {
                this.alertService.error('Você precisa selecionar ao menos um favorecido');
            }
        }
    }

    setSelected(index) {
        const orderItens = this.currentPurchaseValue.purchaseItens[index].order.orderItens;
        this.currentPurchaseValue.purchaseValue = 0;
        this.currentPurchaseValue.purchaseItens[index].order.orderItens = [];
        let contractId = this.currentPurchaseValue.purchaseItens[index].order.assignorContractId
        this.colaboradoresList.forEach(obj => {
            if (obj.selected) {
                let orderItem = null;
                if (orderItens && obj.cartao) {
                    orderItem = orderItens.find(x => x.cardId === obj.cartao.cardId);
                }
                if (orderItem) {
                    this.currentPurchaseValue.purchaseItens[index].order.orderItens.push(orderItem);
                    this.currentPurchaseValue.purchaseValue += orderItem.valor;
                } else {
                    const orderItem: OrderItens = new OrderItens();
                    let result = obj.accounts.find( ({assignorContractId}) => assignorContractId === contractId);
                    orderItem.collaboratorId = obj.collaboratorID;
                    orderItem.name = obj.name;
                    orderItem.document = obj.document;
                    orderItem.registry = obj.register;
                    orderItem.hasApp = obj.hasApp;
                    orderItem.hasCard = obj.hasCard;
                    orderItem.referenceValue = result === undefined ? 0 : result.standardValue;
                    orderItem.regularityId = result === undefined ? 0 : result.standardPeriodId;
                    orderItem.regularityDescription = result === undefined ? null : result.standardPeriod;
                    orderItem.cardId = result === undefined ? 0 : result.cardId;
                    this.currentPurchaseValue.purchaseItens[index].order.orderItens.push(orderItem);
                }
            }

        });
        this.updateCount();
    }

    updateEsporadicos() {
        /* this.colaboradoresList.forEach(obj => {
            if (obj.esporadico) {
                obj.selected = true;
            }
        });
        this.alterado = !this.alterado; */
    }

    updateSelected() {
        /* this.colaboradoresList.forEach(obj => {
            if (!obj.selected) {
                obj.esporadico = false;
            }
        });
        this.alterado = !this.alterado; */
    }

    public newColaborador() {
        const state: RouterState = this.router.routerState;
        this.router.navigate(['portal/colaborador/create'], { queryParams: { urlReturn: state.snapshot.url } });
    }
    navigateToColaborador() {
        this.router.navigate(['portal/colaborador/']);
    }

    /*deletedSelect(toDeleteColaborador: Colaborador) {
        const toDeletePedidoItems = this.currentPedidoValue.pedidoItens.find(x => x.cpf === toDeleteColaborador.documento);
        if (toDeletePedidoItems) {
            this.currentPedidoValue.pedidoItens.splice(this.currentPedidoValue.pedidoItens.indexOf(toDeletePedidoItems), 1);
        }
        this.colaboradoresList.splice(this.colaboradoresList.indexOf(toDeleteColaborador), 1);
    }*/
}
